export function formatDate(timestamp) {
    const formatter = new Intl.DateTimeFormat("fa-IR", {
        day: "numeric",
        month: "short"
    })
    return formatter.format(timestamp * 1000)
}